"use client";

import { CAMPAIGN_TYPES, CampaignTypeValue } from "./constants";
import { EditPro013Modal } from "./edit-pro013-modal";
import { EditPro014Modal } from "./edit-pro014-modal";
import { EditPro017Modal } from "./edit-pro017-modal";

interface EditCampaignModalProps {
  campaignCode: number;
  campaignType: CampaignTypeValue;
}

export function EditCampaignModal({
  campaignCode,
  campaignType,
}: EditCampaignModalProps) {
  if (campaignType === CAMPAIGN_TYPES.PRO013) {
    return <EditPro013Modal campaignCode={campaignCode} />;
  }

  if (campaignType === CAMPAIGN_TYPES.PRO014) {
    return <EditPro014Modal campaignCode={campaignCode} />;
  }

  if (campaignType === CAMPAIGN_TYPES.PRO017) {
    return <EditPro017Modal campaignCode={campaignCode} />;
  }

  return (
    <div className="flex items-center justify-center h-64">
      <p className="text-muted-foreground">Tipo de campanha não suportado: {campaignType}</p>
    </div>
  );
}
